import sports from './sports/sports';

const ovp = sports;

export default ovp;
